import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Bell, CheckCheck } from "lucide-react";
import api from "../lib/api";

export default function Notifications() {
  const [items, setItems] = useState([]);

  const refresh = async () => {
    const { data } = await api.get("/notifications");
    setItems(data || []);
  };

  useEffect(() => { refresh(); }, []);

  const markAll = async () => {
    await api.post("/notifications/read-all");
    refresh();
  };

  const open = async (n) => {
    if (!n.read) await api.post(`/notifications/${n.id}/read`);
    refresh();
  };

  return (
    <div className="space-y-5" data-testid="notifications-page">
      <div className="flex items-end justify-between">
        <div>
          <div className="label-overline">Alerts</div>
          <h1 className="font-heading text-3xl font-bold tracking-tight mt-1">Notifications</h1>
        </div>
        <button onClick={markAll} className="btn-secondary text-sm" data-testid="mark-all-btn"><CheckCheck size={16} /> Mark all read</button>
      </div>

      {items.length === 0 ? (
        <div className="card-base p-8 text-center" data-testid="notif-empty">
          <Bell className="mx-auto text-sage-500" size={28} />
          <div className="mt-3 font-heading font-semibold">All quiet for now.</div>
        </div>
      ) : (
        <ul className="space-y-2">
          {items.map((n) => (
            <li key={n.id}>
              <Link to={n.link || "#"} onClick={() => open(n)} className={`card-base p-4 flex items-start justify-between gap-3 ${n.read ? "opacity-80" : ""}`} data-testid={`notif-${n.id}`}>
                <div>
                  <div className="font-heading font-semibold">{n.title}</div>
                  <div className="text-sm text-ink-600 mt-0.5">{n.body}</div>
                  <div className="text-xs text-ink-500 mt-1">{new Date(n.created_at).toLocaleString()}</div>
                </div>
                {!n.read && <span className="w-2 h-2 mt-2 rounded-full bg-terracotta-500" />}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
